import Apis from '@/Apis/_'
import ResponseApi from '../interfaces/FactoryResponse'
import { CoreBase, ICoreBase } from './CoreBase'

class PrestadorRecebimento extends CoreBase implements IPrestadorRecebimento {
  async getPrestadorRecebimentoAll(params: any): Promise<ResponseApi> {
    const response = await Apis.RemuneracaoMedica.RemuneracaoMedicaApi.getPrestadorRecebimentoAll(params)
    return response
  }

  async getTiposCarga(): Promise<ResponseApi> {
    const response = await Apis.RemuneracaoMedica.RemuneracaoMedicaApi.getTiposCarga()
    return response
  }

  async getItemsMonitoramentoCargas(params: any): Promise<ResponseApi> {
    const response = await Apis.RemuneracaoMedica.RemuneracaoMedicaApi.getItemsMonitoramentoCargas(params)
    return response
  }

  async getTipoFilter(): Promise<ResponseApi> {
    const response = await Apis.RemuneracaoMedica.RemuneracaoMedicaApi.getTipoFilter()
    return response
  }

  async getTiposCargaDownload(): Promise<ResponseApi> {
    const response = await Apis.RemuneracaoMedica.RemuneracaoMedicaApi.getTiposCargaDownload()
    return response
  }

  async atualizarNotaFiscal(params: any): Promise<ResponseApi> {
    const response = await Apis.RemuneracaoMedica.RemuneracaoMedicaApi.atualizarNotaFiscal(params)
    return response
  }

  async deletarNotaFiscal(id: string): Promise<ResponseApi> {
    const response = await Apis.RemuneracaoMedica.RemuneracaoMedicaApi.deletarNotaFiscal(id)
    return response
  }

  async deletarRepasse(id: string): Promise<ResponseApi> {
    const response = await Apis.RemuneracaoMedica.RemuneracaoMedicaApi.deletarRepasse(id)
    return response
  }

  async geRecebimentoById(id: string) : Promise<ResponseApi> {
    const response = await Apis.RemuneracaoMedica.RemuneracaoMedicaApi.geRecebimentoById(id)
    return response
  }

  async getRecebimentoNotaFiscalById(id: string) : Promise<ResponseApi> {
    const response = await Apis.RemuneracaoMedica.RemuneracaoMedicaApi.getRecebimentoNotaFiscalById(id)
    return response
  }

  async importacaoArquivoRecebimento(form: any, tipoCarga: any) : Promise<ResponseApi> {
    const response = await Apis.RemuneracaoMedica.RemuneracaoMedicaApi.importacaoArquivoRecebimento(form, tipoCarga)
    return response
  }

  async uploadNotaFiscal(params: any) : Promise<ResponseApi> {
    const response = await Apis.RemuneracaoMedica.RemuneracaoMedicaApi.uploadNotaFiscal(params)
    return response
  }

  async getLogs() : Promise<ResponseApi> {
    const response = await Apis.RemuneracaoMedica.RemuneracaoMedicaApi.getLogs()
    return response
  }

  async sendEmailCobrancaNotaFiscal(params: any): Promise<ResponseApi> {
    const response = await Apis.RemuneracaoMedica.RemuneracaoMedicaApi.sendEmailCobrancaNotaFiscal(params)
    return response
  }

  async getDocumentoPrestadorRecebimento(id: string): Promise<ResponseApi> {
    const response = await Apis.RemuneracaoMedica.RemuneracaoMedicaApi.getDocumentoPrestadorRecebimento(id)
    return response
  }

  async criarAgrupamentoPrestadorRecebimento(params: any): Promise<ResponseApi> {
    const response = await Apis.RemuneracaoMedica.RemuneracaoMedicaApi.criarAgrupamentoPrestadorRecebimento(params)
    return response
  }

  async getRelatorioRecebimento(params: any): Promise<ResponseApi> {
    const response = await Apis.RemuneracaoMedica.RemuneracaoMedicaApi.getRelatorioRecebimento(params)
    return response
  }

  async atualizarAgrupamento(params: any): Promise<ResponseApi> {
    const response = await Apis.RemuneracaoMedica.RemuneracaoMedicaApi.atualizarAgrupamento(params)
    return response
  }

  async deletarDocumentoPrestadorRecebimento(params: any): Promise<ResponseApi> {
    const response = await Apis.RemuneracaoMedica.RemuneracaoMedicaApi.deletarDocumentoPrestadorRecebimento(params)
    return response
  }

  async deletarDocumento(params: any): Promise<ResponseApi> {
    const response = await Apis.RemuneracaoMedica.RemuneracaoMedicaApi.deletarDocumento(params)
    return response
  }

  async download(params: any): Promise<ResponseApi> {
    const response = await Apis.RemuneracaoMedica.RemuneracaoMedicaApi.download(params)
    return response
  }

  async provisionarRemuneracao(params: any): Promise<ResponseApi> {
    const response = await Apis.RemuneracaoMedica.RemuneracaoMedicaApi.provisionarRemuneracao(params)
    return response
  }

  async deleteNotaFiscal(params: any): Promise<ResponseApi> {
    const response = await Apis.RemuneracaoMedica.RemuneracaoMedicaApi.deleteNotaFiscal(params)
    return response
  }

  async cancelarProvisionamentoRemuneracao(params): Promise<ResponseApi> {
    const response = await Apis.RemuneracaoMedica.RemuneracaoMedicaApi.cancelarProvisionamentoRemuneracao(params)
    return response
  }

  async notificarManualmenteRecebimento(params: any): Promise<ResponseApi> {
    const response = await Apis.RemuneracaoMedica.RemuneracaoMedicaApi.notificarManualmenteRecebimento(params)
    return response
  }

  async getFontePagadoraAll(): Promise<ResponseApi> {
    const response = await Apis.RemuneracaoMedica.RemuneracaoMedicaApi.getFontePagadoraAll()
    return response
  }

  async getTipoList(): Promise<ResponseApi> {
    const response = await Apis.RemuneracaoMedica.RemuneracaoMedicaApi.getTipoList()
    return response
  }

  async getLayoutEmailList(): Promise<ResponseApi> {
    const response = await Apis.RemuneracaoMedica.RemuneracaoMedicaApi.getLayoutEmailList()
    return response
  }

  async getLayoutEmailById(params: any): Promise<ResponseApi> {
    const response = await Apis.RemuneracaoMedica.RemuneracaoMedicaApi.getLayoutEmailById(params)
    return response
  }

  async salvarLayoutEmail(params: any): Promise<ResponseApi> {
    const response = await Apis.RemuneracaoMedica.RemuneracaoMedicaApi.salvarLayoutEmail(params)
    return response
  }

  async getAllProcedimentosRecalculo(params: any): Promise<ResponseApi> {
    const response = await Apis.RemuneracaoMedica.RemuneracaoMedicaApi.getAllProcedimentosRecalculo(params)
    return response
  }

  async getTipoItens(): Promise<ResponseApi> {
    const response = await Apis.RemuneracaoMedica.RemuneracaoMedicaApi.getTipoItens()
    return response
  }

  async getGerarRepassePrestadores(param: any): Promise<ResponseApi> {
    const response = await Apis.RemuneracaoMedica.RemuneracaoMedicaApi.getGerarRepassePrestadores(param)
    return response
  }

  async getStatusList(): Promise<ResponseApi> {
    const response = await Apis.RemuneracaoMedica.RemuneracaoMedicaApi.getStatusList()
    return response
  }

  async gerarRepasses(params: any): Promise<ResponseApi> {
    const response = await Apis.RemuneracaoMedica.RemuneracaoMedicaApi.gerarRepasses(params)
    return response
  }

  async getCondicaoPagamento(): Promise<ResponseApi> {
    const response = await Apis.RemuneracaoMedica.RemuneracaoMedicaApi.getCondicaoPagamento()
    return response
  }

  async getGeracaoRepasse(params: any): Promise<ResponseApi> {
    const response = await Apis.RemuneracaoMedica.RemuneracaoMedicaApi.getGeracaoRepasse(params)
    return response
  }

  async getTipoEnum(): Promise<ResponseApi> {
    const response = await Apis.RemuneracaoMedica.RemuneracaoMedicaApi.getTipoEnum()
    return response
  }

  async getGeracaoDeRepassesItemsVisualizar(params: any): Promise<ResponseApi> {
    const response = await Apis.RemuneracaoMedica.RemuneracaoMedicaApi.getGeracaoDeRepassesItemsVisualizar(params)
    return response
  }

  async getCargasVisualizarItems(params: any): Promise<ResponseApi> {
    const response = await Apis.RemuneracaoMedica.RemuneracaoMedicaApi.getCargasVisualizarItems(params)
    return response
  }

  async getProcedimentosDescartados(params: any): Promise<ResponseApi> {
    const response = await Apis.RemuneracaoMedica.RemuneracaoMedicaApi.getProcedimentosDescartados(params)
    return response
  }

  async getRegistrosValidacao(params: any): Promise<ResponseApi> {
    const response = await Apis.RemuneracaoMedica.RemuneracaoMedicaApi.getRegistrosValidacao(params)
    return response
  }

  async fecharGeracaoRepasse(params: any): Promise<ResponseApi> {
    const response = await Apis.RemuneracaoMedica.RemuneracaoMedicaApi.fecharGeracaoRepasse(params)
    return response
  }

  async getTabelasAMB(): Promise<ResponseApi> {
    const response = await Apis.RemuneracaoMedica.RemuneracaoMedicaApi.getTabelasAMB()
    return response
  }

  async salvarCodigoAmb(params: any): Promise<ResponseApi> {
    const response = await Apis.RemuneracaoMedica.RemuneracaoMedicaApi.salvarCodigoAmb(params)
    return response
  }

  async updateItemTabelaAmb(params: any): Promise<ResponseApi> {
    const response = await Apis.RemuneracaoMedica.RemuneracaoMedicaApi.updateItemTabelaAmb(params)
    return response
  }

  async saveEditTableRules(params: any): Promise<ResponseApi> {
    const response = await Apis.RemuneracaoMedica.RemuneracaoMedicaApi.saveEditTableRules(params)
    return response
  }

  async deleteItemTabelaAmb(id: string): Promise<ResponseApi> {
    const response = await Apis.RemuneracaoMedica.RemuneracaoMedicaApi.deleteItemTabelaAmb(id)
    return response
  }

  async getGrupoRepasseAll(): Promise<ResponseApi> {
    const response = await Apis.RemuneracaoMedica.RemuneracaoMedicaApi.getGrupoRepasseAll()
    return response
  }

  async getTemplateNotificacaoConfig(param: any): Promise<ResponseApi> {
    const response = await Apis.RemuneracaoMedica.RemuneracaoMedicaApi.getTemplateNotificacaoConfig(param)
    return response
  }

  async getDocumentoByPrestadorRecebimentoId(param: any): Promise<ResponseApi> {
    const response = await Apis.RemuneracaoMedica.RemuneracaoMedicaApi.getDocumentoByPrestadorRecebimentoId(param)
    return response
  }

  async getPessoaPrestadorAll(params: any): Promise<ResponseApi> {
    const response = await Apis.RemuneracaoMedica.RemuneracaoMedicaApi.getPessoaPrestadorAll(params)
    return response
  }

  async getFontesPagadoras(): Promise<ResponseApi> {
    const response = await Apis.RemuneracaoMedica.RemuneracaoMedicaApi.getFontesPagadoras()
    return response
  }

  async getPeriodos(): Promise<ResponseApi> {
    const response = await Apis.RemuneracaoMedica.RemuneracaoMedicaApi.getPeriodos()
    return response
  }

  async getImpostoPrestador(params: any): Promise<ResponseApi> {
    const response = await Apis.RemuneracaoMedica.RemuneracaoMedicaApi.getImpostoPrestador(params)
    return response
  }

  async alterarPrestador(params: any): Promise<ResponseApi> {
    const response = await Apis.RemuneracaoMedica.RemuneracaoMedicaApi.alterarPrestador(params)
    return response
  }

  async getTabelasDeReferencia(): Promise<ResponseApi> {
    const response = await Apis.RemuneracaoMedica.RemuneracaoMedicaApi.getTabelasDeReferencia()
    return response
  }

  async getItemsRecebimentoMonitor(param: any): Promise<ResponseApi> {
    const response = await Apis.RemuneracaoMedica.RemuneracaoMedicaApi.getItemsRecebimentoMonitor(param)
    return response
  }

  async getRepassesCarregados(param: any): Promise<ResponseApi> {
    const response = await Apis.RemuneracaoMedica.RemuneracaoMedicaApi.getRepassesCarregados(param)
    return response
  }

  async downloadArquivosCargaRemuneracao(id: string): Promise<ResponseApi> {
    const response = await Apis.RemuneracaoMedica.RemuneracaoMedicaApi.downloadArquivosCargaRemuneracao(id)
    return response
  }

  async downloadCargasGeracao(id: string): Promise<ResponseApi> {
    const response = await Apis.RemuneracaoMedica.RemuneracaoMedicaApi.downloadCargasGeracao(id)
    return response
  }

  async getItemsRecebimentoErros(params: any): Promise<ResponseApi> {
    const response = await Apis.RemuneracaoMedica.RemuneracaoMedicaApi.getItemsRecebimentoErros(params)
    return response
  }

  async getItensByTabelaDeReferenciaId(params: any): Promise<ResponseApi> {
    const response = await Apis.RemuneracaoMedica.RemuneracaoMedicaApi.getItensByTabelaDeReferenciaId(params)
    return response
  }

  async createItensByTabelaDeReferenciaId(params: any): Promise<ResponseApi> {
    const response = await Apis.RemuneracaoMedica.RemuneracaoMedicaApi.createItensByTabelaDeReferenciaId(params)
    return response
  }

  async updateItemByTabelaDeReferenciaId(params: any): Promise<ResponseApi> {
    const response = await Apis.RemuneracaoMedica.RemuneracaoMedicaApi.updateItemByTabelaDeReferenciaId(params)
    return response
  }

  async deleteItemByTabelaDeReferenciaId(params: any): Promise<ResponseApi> {
    const response = await Apis.RemuneracaoMedica.RemuneracaoMedicaApi.deleteItemByTabelaDeReferenciaId(params)
    return response
  }

  async getBackofficeProducao(params: any): Promise<ResponseApi> {
    const response = await Apis.RemuneracaoMedica.RemuneracaoMedicaApi.getBackofficeProducao(params)
    return response
  }

  async getItensDoRepasse(params: any, id: string): Promise<ResponseApi> {
    const response = await Apis.RemuneracaoMedica.RemuneracaoMedicaApi.getItensDoRepasse(params, id)
    return response
  }

  async generateRelatorioGeracaoRepasse(params: any): Promise<ResponseApi> {
    const response = await Apis.RemuneracaoMedica.RemuneracaoMedicaApi.generateRelatorioGeracaoRepasse(params)
    return response
  }

  async liberarRepasses(params: any): Promise<ResponseApi> {
    const response = await Apis.RemuneracaoMedica.RemuneracaoMedicaApi.liberarRepasses(params)
    return response
  }

  async liberarRepasseUnico(params: any): Promise<ResponseApi> {
    const response = await Apis.RemuneracaoMedica.RemuneracaoMedicaApi.liberarRepasseUnico(params)
    return response
  }

  async integrarRepasses(params: any): Promise<ResponseApi> {
    const response = await Apis.RemuneracaoMedica.RemuneracaoMedicaApi.integrarRepasses(params)
    return response
  }

  async integrarRepasseUnico(params: any): Promise<ResponseApi> {
    const response = await Apis.RemuneracaoMedica.RemuneracaoMedicaApi.integrarRepasseUnico(params)
    return response
  }

  async descartarRepasses(params: any): Promise<ResponseApi> {
    const response = await Apis.RemuneracaoMedica.RemuneracaoMedicaApi.descartarRepasses(params)
    return response
  }

  async getTipoCargaDownload(params: any): Promise<ResponseApi> {
    const response = await Apis.RemuneracaoMedica.RemuneracaoMedicaApi.getTipoCargaDownload(params)
    return response
  }

  async enfileirar(params: any): Promise<ResponseApi> {
    const response = await Apis.RemuneracaoMedica.RemuneracaoMedicaApi.enfileirar(params)
    return response
  }

  async desfazerIntegracao(params: any): Promise<ResponseApi> {
    const response = await Apis.RemuneracaoMedica.RemuneracaoMedicaApi.desfazerIntegracao(params)
    return response
  }

  async desfazerLiberacao(params: any): Promise<ResponseApi> {
    const response = await Apis.RemuneracaoMedica.RemuneracaoMedicaApi.desfazerLiberacao(params)
    return response
  }

  async emitirRelatorio(params: any): Promise<ResponseApi> {
    const response = await Apis.RemuneracaoMedica.RemuneracaoMedicaApi.emitirRelatorio(params)
    return response
  }

  async emitirRelatoriosEmLote(params: any): Promise<ResponseApi> {
    const response = await Apis.RemuneracaoMedica.RemuneracaoMedicaApi.emitirRelatoriosEmLote(params)
    return response
  }

  async emitirRelatorioTabelaPropria(params: any): Promise<ResponseApi> {
    const response = await Apis.RemuneracaoMedica.RemuneracaoMedicaApi.emitirRelatorioTabelaPropria(params)
    return response
  }

  async getEmissaoRelatorio(params: any): Promise<ResponseApi> {
    const response = await Apis.RemuneracaoMedica.RemuneracaoMedicaApi.getEmissaoRelatorio(params)
    return response
  }

  async getDescarteRepasses(params: any): Promise<ResponseApi> {
    const response = await Apis.RemuneracaoMedica.RemuneracaoMedicaApi.getDescarteRepasses(params)
    return response
  }

  async getRecalculoRepasse(params: any): Promise<ResponseApi> {
    const response = await Apis.RemuneracaoMedica.RemuneracaoMedicaApi.getRecalculoRepasse(params)
    return response
  }

  async filtroDownloadNotaFiscal(params: any): Promise<ResponseApi> {
    const response = await Apis.RemuneracaoMedica.RemuneracaoMedicaApi.filtroDownloadNotaFiscal(params)
    return response
  }

  async validarRepasses(params: any): Promise<ResponseApi> {
    const response = await Apis.RemuneracaoMedica.RemuneracaoMedicaApi.validarRepasses(params)
    return response
  }

  async alterarSituacoesEmLote(params: any): Promise<ResponseApi> {
    const response = await Apis.RemuneracaoMedica.RemuneracaoMedicaApi.alterarSituacoesEmLote(params)
    return response
  }

  async saveAluguelPrestador(params: any): Promise<ResponseApi> {
    const response = await Apis.RemuneracaoMedica.RemuneracaoMedicaApi.saveAluguelPrestador(params)
    return response
  }

  async saveAlterarPontuacaoProfissional(params: any): Promise<ResponseApi> {
    const response = await Apis.RemuneracaoMedica.RemuneracaoMedicaApi.saveAlterarPontuacaoProfissional(params)
    return response
  }

  async saveNovoItemAvulsoRepasse(params: any): Promise<ResponseApi> {
    const response = await Apis.RemuneracaoMedica.RemuneracaoMedicaApi.saveNovoItemAvulsoRepasse(params)
    return response
  }

  async saveInsercaoDeRegistrosEmLoteCalcularRepasse(params: any): Promise<ResponseApi> {
    const response = await Apis.RemuneracaoMedica.RemuneracaoMedicaApi.saveInsercaoDeRegistrosEmLoteCalcularRepasse(params)
    return response
  }

  async putInsercaoDeRegistrosEmLoteCalcularRepasse(params: any): Promise<ResponseApi> {
    const response = await Apis.RemuneracaoMedica.RemuneracaoMedicaApi.putInsercaoDeRegistrosEmLoteCalcularRepasse(params)
    return response
  }

  async putNovoItemFixoCargaPlanilha(params: any): Promise<ResponseApi> {
    const response = await Apis.RemuneracaoMedica.RemuneracaoMedicaApi.putNovoItemFixoCargaPlanilha(params)
    return response
  }

  async saveNovoItemAvulsoCalcularRepasse(params: any): Promise<ResponseApi> {
    const response = await Apis.RemuneracaoMedica.RemuneracaoMedicaApi.saveNovoItemAvulsoCalcularRepasse(params)
    return response
  }

  async saveAlterarPrestador(params: any): Promise<ResponseApi> {
    const response = await Apis.RemuneracaoMedica.RemuneracaoMedicaApi.saveAlterarPrestador(params)
    return response
  }

  async getGeracaoDeRepasseItensPrestador(params: any): Promise<ResponseApi> {
    const response = await Apis.RemuneracaoMedica.RemuneracaoMedicaApi.getGeracaoDeRepasseItensPrestador(params)
    return response
  }

  async alterarFuncaoGeracaoRepasse(params: any): Promise<ResponseApi> {
    const response = await Apis.RemuneracaoMedica.RemuneracaoMedicaApi.alterarFuncaoGeracaoRepasse(params)
    return response
  }

  async getAllDescontosPrestador(params: any): Promise<ResponseApi> {
    const response = await Apis.RemuneracaoMedica.RemuneracaoMedicaApi.getAllDescontosPrestador(params)
    return response
  }

  async getProfissionalPontuacao(params: any): Promise<ResponseApi> {
    const response = await Apis.RemuneracaoMedica.RemuneracaoMedicaApi.getProfissionalPontuacao(params)
    return response
  }

  async getPontuacaoProfissional(): Promise<ResponseApi> {
    const response = await Apis.RemuneracaoMedica.RemuneracaoMedicaApi.getPontuacaoProfissional()
    return response
  }

  async getProcedimentos(): Promise<ResponseApi> {
    const response = await Apis.RemuneracaoMedica.RemuneracaoMedicaApi.getProcedimentos()
    return response
  }

  async getValidacaoErros(param: any): Promise<ResponseApi> {
    const response = await Apis.RemuneracaoMedica.RemuneracaoMedicaApi.getValidacaoErros(param)
    return response
  }

  async getTransacaoFinanceira(): Promise<ResponseApi> {
    const response = await Apis.RemuneracaoMedica.RemuneracaoMedicaApi.getTransacaoFinanceira()
    return response
  }

  async getCentroDeCusto(): Promise<ResponseApi> {
    const response = await Apis.RemuneracaoMedica.RemuneracaoMedicaApi.getCentroDeCusto()
    return response
  }

  async getHistoricoSituacao(params: any): Promise<ResponseApi> {
    const response = await Apis.RemuneracaoMedica.RemuneracaoMedicaApi.getHistoricoSituacao(params)
    return response
  }

  async getHistoricoGeracaoRepasse(params: any): Promise<ResponseApi> {
    const response = await Apis.RemuneracaoMedica.RemuneracaoMedicaApi.getHistoricoGeracaoRepasse(params)
    return response
  }

  async getValidacaoResultado(param: any): Promise<ResponseApi> {
    const response = await Apis.RemuneracaoMedica.RemuneracaoMedicaApi.getValidacaoResultado(param)
    return response
  }

  async getHistoricoCadastroAluguel(params: any): Promise<ResponseApi> {
    const response = await Apis.RemuneracaoMedica.RemuneracaoMedicaApi.getHistoricoCadastroAluguel(params)
    return response
  }

  async getHistoricoGeracaoItens(params: any): Promise<ResponseApi> {
    const response = await Apis.RemuneracaoMedica.RemuneracaoMedicaApi.getHistoricoGeracaoItens(params)
    return response
  }

  async getHistoricoPontuacao(params: any): Promise<ResponseApi> {
    const response = await Apis.RemuneracaoMedica.RemuneracaoMedicaApi.getHistoricoPontuacao(params)
    return response
  }

  async getHistoricoPontuacaoProfissional(params: any): Promise<ResponseApi> {
    const response = await Apis.RemuneracaoMedica.RemuneracaoMedicaApi.getHistoricoPontuacaoProfissional(params)
    return response
  }

  async getProfissionais(): Promise<ResponseApi> {
    const response = await Apis.RemuneracaoMedica.RemuneracaoMedicaApi.getProfissionais()
    return response
  }

  async getFuncoesProfissionalExecutante(): Promise<ResponseApi> {
    const response = await Apis.RemuneracaoMedica.RemuneracaoMedicaApi.getFuncoesProfissionalExecutante()
    return response
  }

  async getConveniosRepasse(params: any): Promise<ResponseApi> {
    const response = await Apis.RemuneracaoMedica.RemuneracaoMedicaApi.getConveniosRepasse(params)
    return response
  }

  async getPlanosRepasse(params: any): Promise<ResponseApi> {
    const response = await Apis.RemuneracaoMedica.RemuneracaoMedicaApi.getPlanosRepasse(params)
    return response
  }

  async getViasAcesso(): Promise<ResponseApi> {
    const response = await Apis.RemuneracaoMedica.RemuneracaoMedicaApi.getViasAcesso()
    return response
  }

  async getMotivoInclusao(): Promise<ResponseApi> {
    const response = await Apis.RemuneracaoMedica.RemuneracaoMedicaApi.getMotivoInclusao()
    return response
  }

  async getItemsRegrasProfissional(params: any): Promise<ResponseApi> {
    const response = await Apis.RemuneracaoMedica.RemuneracaoMedicaApi.getItemsRegrasProfissional(params)
    return response
  }

  async getTabelaPrecoAll(): Promise<ResponseApi> {
    const response = await Apis.RemuneracaoMedica.RemuneracaoMedicaApi.getTabelaPrecoAll()
    return response
  }

  async getTabelaPrecoDetails(): Promise<ResponseApi> {
    const response = await Apis.RemuneracaoMedica.RemuneracaoMedicaApi.getTabelaPrecoDetails()
    return response
  }

  async deleteItemTabelaPreco(id: number): Promise<ResponseApi> {
    const response = await Apis.RemuneracaoMedica.RemuneracaoMedicaApi.deleteItemTabelaPreco(id)
    return response
  }

  async criarTabelaPreco(params: any): Promise<ResponseApi> {
    const response = await Apis.RemuneracaoMedica.RemuneracaoMedicaApi.criarTabelaPreco(params)
    return response
  }

  async getTabelaPrecoIndice(): Promise<ResponseApi> {
    const response = await Apis.RemuneracaoMedica.RemuneracaoMedicaApi.getTabelaPrecoIndice()
    return response
  }

  async getConvenioRegras(): Promise<ResponseApi> {
    const response = await Apis.RemuneracaoMedica.RemuneracaoMedicaApi.getConvenioRegras()
    return response
  }

  async getConvenio(): Promise<ResponseApi> {
    const response = await Apis.RemuneracaoMedica.RemuneracaoMedicaApi.getConvenio()
    return response
  }

  async getItemsTabelaAMB(params: any): Promise<ResponseApi> {
    const response = await Apis.RemuneracaoMedica.RemuneracaoMedicaApi.getItemsTabelaAMB(params)
    return response
  }

  async getItemsCargaRemuneracaoAll(params: any): Promise<ResponseApi> {
    const response = await Apis.RemuneracaoMedica.RemuneracaoMedicaApi.getItemsCargaRemuneracaoAll(params)
    return response
  }

  async getItemsDownloadNotasFiscais(params: any): Promise<ResponseApi> {
    const response = await Apis.RemuneracaoMedica.RemuneracaoMedicaApi.getItemsDownloadNotasFiscais(params)
    return response
  }

  async desfazerRepasse(params: any): Promise<ResponseApi> {
    const response = await Apis.RemuneracaoMedica.RemuneracaoMedicaApi.desfazerRepasse(params)
    return response
  }

  async getAllItemsSenioridade(params: any): Promise<ResponseApi> {
    const response = await Apis.RemuneracaoMedica.RemuneracaoMedicaApi.getAllItemsSenioridade(params)
    return response
  }

  async createItemsSenioridade(params: any): Promise<ResponseApi> {
    const response = await Apis.RemuneracaoMedica.RemuneracaoMedicaApi.createItemsSenioridade(params)
    return response
  }

  async updateItemsSenioridade(params: any): Promise<ResponseApi> {
    const response = await Apis.RemuneracaoMedica.RemuneracaoMedicaApi.updateItemsSenioridade(params)
    return response
  }

  async deleteItemSenioridade(id: string): Promise<ResponseApi> {
    const response = await Apis.RemuneracaoMedica.RemuneracaoMedicaApi.deleteItemSenioridade(id)
    return response
  }

  async getPontuacaoProfissionalAll(params: any): Promise<ResponseApi> {
    const response = await Apis.RemuneracaoMedica.RemuneracaoMedicaApi.getPontuacaoProfissionalAll(params)
    return response
  }

  async deleteVinculoRelatorio(params: any): Promise<ResponseApi> {
    const response = await Apis.RemuneracaoMedica.RemuneracaoMedicaApi.deleteVinculoRelatorio(params)
    return response
  }

  async deleteImpostoPrestador(param: any): Promise<ResponseApi> {
    const response = await Apis.RemuneracaoMedica.RemuneracaoMedicaApi.deleteImpostoPrestador(param)
    return response
  }

  async criarVinculoRelatorio(params: any): Promise<ResponseApi> {
    const response = await Apis.RemuneracaoMedica.RemuneracaoMedicaApi.criarVinculoRelatorio(params)
    return response
  }

  async criarImpostoPrestador(params: any): Promise<ResponseApi> {
    const response = await Apis.RemuneracaoMedica.RemuneracaoMedicaApi.criarImpostoPrestador(params)
    return response
  }

  async getVinculosRelatorios(params: any): Promise<ResponseApi> {
    const response = await Apis.RemuneracaoMedica.RemuneracaoMedicaApi.getVinculosRelatorios(params)
    return response
  }

  async getImpostoPrestadores(params: any): Promise<ResponseApi> {
    const response = await Apis.RemuneracaoMedica.RemuneracaoMedicaApi.getImpostoPrestadores(params)
    return response
  }

  async getRelatoriosAll(): Promise<ResponseApi> {
    const response = await Apis.RemuneracaoMedica.RemuneracaoMedicaApi.getRelatoriosAll()
    return response
  }

  async createPontuacaoProfissional(params: any): Promise<ResponseApi> {
    const response = await Apis.RemuneracaoMedica.RemuneracaoMedicaApi.createPontuacaoProfissional(params)
    return response
  }

  async updatePontuacaoProfissional(params: any): Promise<ResponseApi> {
    const response = await Apis.RemuneracaoMedica.RemuneracaoMedicaApi.updatePontuacaoProfissional(params)
    return response
  }

  async deletePontuacaoProfissional(id: string): Promise<ResponseApi> {
    const response = await Apis.RemuneracaoMedica.RemuneracaoMedicaApi.deletePontuacaoProfissional(id)
    return response
  }

  async getTaxaAluguelAll(params: any): Promise<ResponseApi> {
    const response = await Apis.RemuneracaoMedica.RemuneracaoMedicaApi.getTaxaAluguelAll(params)
    return response
  }

  async createTaxaAluguel(params: any): Promise<ResponseApi> {
    const response = await Apis.RemuneracaoMedica.RemuneracaoMedicaApi.createTaxaAluguel(params)
    return response
  }

  async updateTaxaAluguel(params: any): Promise<ResponseApi> {
    const response = await Apis.RemuneracaoMedica.RemuneracaoMedicaApi.updateTaxaAluguel(params)
    return response
  }

  async deleteTaxaAluguel(id: string): Promise<ResponseApi> {
    const response = await Apis.RemuneracaoMedica.RemuneracaoMedicaApi.deleteTaxaAluguel(id)
    return response
  }

  async excluirItemRepasse(params: any): Promise<ResponseApi> {
    const response = await Apis.RemuneracaoMedica.RemuneracaoMedicaApi.excluirItemRepasse(params)
    return response
  }

  async getPrestadoresRepasse(params: any): Promise<ResponseApi> {
    const response = await Apis.RemuneracaoMedica.RemuneracaoMedicaApi.getPrestadoresRepasse(params)
    return response
  }

  async getStatusGeracaoRepasse(): Promise<ResponseApi> {
    const response = await Apis.RemuneracaoMedica.RemuneracaoMedicaApi.getStatusGeracaoRepasse()
    return response
  }

  async getGrupoHospital(): Promise<ResponseApi> {
    const response = await Apis.RemuneracaoMedica.RemuneracaoMedicaApi.getGrupoHospital()
    return response
  }

  async getBackofficeChatItems(params: any): Promise<ResponseApi> {
    const response = await Apis.RemuneracaoMedica.RemuneracaoMedicaApi.getBackofficeChatItems(params)
    return response
  }

  async getChatsInfo(param: any): Promise<ResponseApi> {
    const response = await Apis.RemuneracaoMedica.RemuneracaoMedicaApi.getChatsInfo(param)
    return response
  }

  async encerrarAtendimento(param: any): Promise<ResponseApi> {
    const response = await Apis.RemuneracaoMedica.RemuneracaoMedicaApi.encerrarAtendimento(param)
    return response
  }

  async integrarItensDeGeracaoDeRepasseNoHis(param: any): Promise<ResponseApi> {
    const response = await Apis.RemuneracaoMedica.RemuneracaoMedicaApi.integrarItensDeGeracaoDeRepasseNoHis(param)
    return response
  }

  async liberarItensDeGeracaoDeRepasseNoHis(param: any): Promise<ResponseApi> {
    const response = await Apis.RemuneracaoMedica.RemuneracaoMedicaApi.liberarItensDeGeracaoDeRepasseNoHis(param)
    return response
  }

  async getAllFeriados(params: any): Promise<ResponseApi> {
    const response = await Apis.RemuneracaoMedica.RemuneracaoMedicaApi.getAllFeriados(params)
    return response
  }

  async getAllAgendaGarantiaMinimaPeriodo(params: any): Promise<ResponseApi> {
    const response = await Apis.RemuneracaoMedica.RemuneracaoMedicaApi.getAllAgendaGarantiaMinimaPeriodo(params)
    return response
  }

  async getAgendaGarantiaMinimaPeriodoById(params: any): Promise<ResponseApi> {
    const response = await Apis.RemuneracaoMedica.RemuneracaoMedicaApi.getAgendaGarantiaMinimaPeriodoById(params)
    return response
  }

  async deleteItemFeriado(param: any): Promise<ResponseApi> {
    const response = await Apis.RemuneracaoMedica.RemuneracaoMedicaApi.deleteItemFeriado(param)
    return response
  }

  async deleteItemAgendaGarantiaMinima(param: any): Promise<ResponseApi> {
    const response = await Apis.RemuneracaoMedica.RemuneracaoMedicaApi.deleteItemAgendaGarantiaMinima(param)
    return response
  }

  async createItemFeriado(param: any): Promise<ResponseApi> {
    const response = await Apis.RemuneracaoMedica.RemuneracaoMedicaApi.createItemFeriado(param)
    return response
  }

  async updateItemFeriado(param: any): Promise<ResponseApi> {
    const response = await Apis.RemuneracaoMedica.RemuneracaoMedicaApi.updateItemFeriado(param)
    return response
  }

  async updateItemAgendaGarantiaMinimaPeriodo(params: any): Promise<ResponseApi> {
    const response = await Apis.RemuneracaoMedica.RemuneracaoMedicaApi.updateItemAgendaGarantiaMinimaPeriodo(params)
    return response
  }

  async getListaPrestadores() : Promise<ResponseApi> {
    const response = await Apis.RemuneracaoMedica.RemuneracaoMedicaApi.getListaPrestadores()
    return response
  }

  async getCalcularGarantiaMinima(params: any) : Promise<ResponseApi> {
    const response = await Apis.RemuneracaoMedica.RemuneracaoMedicaApi.getCalcularGarantiaMinima(params)
    return response
  }

  async calcularGarantiaMinima(params: any) : Promise<ResponseApi> {
    const response = await Apis.RemuneracaoMedica.RemuneracaoMedicaApi.calcularGarantiaMinima(params)
    return response
  }
}

interface IPrestadorRecebimento extends ICoreBase {
  getPrestadorRecebimentoAll(params: any): Promise<ResponseApi>
  getTiposCarga(): Promise<ResponseApi>
  getItemsMonitoramentoCargas(params: any): Promise<ResponseApi>
  getTipoFilter(): Promise<ResponseApi>
  getTiposCargaDownload(): Promise<ResponseApi>
  getFontePagadoraAll(): Promise<ResponseApi>
  getTipoList(): Promise<ResponseApi>
  getLayoutEmailList(): Promise<ResponseApi>
  getLayoutEmailById(params: any): Promise<ResponseApi>
  salvarLayoutEmail(params: any): Promise<ResponseApi>
  getAllProcedimentosRecalculo(params: any): Promise<ResponseApi>
  getTipoItens(): Promise<ResponseApi>
  getGerarRepassePrestadores(param: any): Promise<ResponseApi>
  getStatusList(): Promise<ResponseApi>
  getCondicaoPagamento(): Promise<ResponseApi>
  gerarRepasses(params: any): Promise<ResponseApi>
  getGeracaoRepasse(params: any): Promise<ResponseApi>
  getTipoEnum(): Promise<ResponseApi>
  getGeracaoDeRepassesItemsVisualizar(params: any): Promise<ResponseApi>
  getCargasVisualizarItems(params: any): Promise<ResponseApi>
  getProcedimentosDescartados(params: any): Promise<ResponseApi>
  getGrupoRepasseAll(): Promise<ResponseApi>
  geRecebimentoById(id: string): Promise<ResponseApi>
  getRecebimentoNotaFiscalById(id: string): Promise<ResponseApi>
  atualizarNotaFiscal(params: any): Promise<ResponseApi>
  deletarDocumentoPrestadorRecebimento(prestadorRecebimentoId: string): Promise<ResponseApi>
  deletarDocumento(prestadorRecebimentoId: string): Promise<ResponseApi>
  importacaoArquivoRecebimento(form: any, tipoCarga: any): Promise<ResponseApi>
  uploadNotaFiscal(params: any): Promise<ResponseApi>
  download(params: any): Promise<ResponseApi>
  getLogs() : Promise<ResponseApi>
  sendEmailCobrancaNotaFiscal(params: any): Promise<ResponseApi>
  getDocumentoPrestadorRecebimento(params: any): Promise<ResponseApi>
  provisionarRemuneracao(params: any): Promise<ResponseApi>
  deleteNotaFiscal(params: any): Promise<ResponseApi>
  cancelarProvisionamentoRemuneracao(params): Promise<ResponseApi>
  criarAgrupamentoPrestadorRecebimento(params: any): Promise<ResponseApi>
  getDocumentoByPrestadorRecebimentoId(params: any): Promise<ResponseApi>
  getRelatorioRecebimento(params: any): Promise<ResponseApi>
  atualizarAgrupamento(params: any): Promise<ResponseApi>
  deletarNotaFiscal(id: string): Promise<ResponseApi>
  deletarRepasse(id: string): Promise<ResponseApi>
  notificarManualmenteRecebimento(params: any): Promise<ResponseApi>
  getPrestadoresRepasse(params: any): Promise<ResponseApi>
  getTemplateNotificacaoConfig(param: any): Promise<ResponseApi>
  getPessoaPrestadorAll(params: any): Promise<ResponseApi>
  getFontesPagadoras(): Promise<ResponseApi>
  getPeriodos(): Promise<ResponseApi>
  getImpostoPrestador(params: any): Promise<ResponseApi>
  alterarPrestador(params: any): Promise<ResponseApi>
  getTabelasDeReferencia(): Promise<ResponseApi>
  getItemsRecebimentoMonitor(param: any): Promise<ResponseApi>
  getRepassesCarregados(param: any): Promise<ResponseApi>
  downloadArquivosCargaRemuneracao(id: string): Promise<ResponseApi>
  downloadCargasGeracao(id: string): Promise<ResponseApi>
  getItemsRecebimentoErros(params: any): Promise<ResponseApi>
  getItensByTabelaDeReferenciaId(params: any): Promise<ResponseApi>
  createItensByTabelaDeReferenciaId(params: any): Promise<ResponseApi>
  updateItemByTabelaDeReferenciaId(params: any): Promise<ResponseApi>
  deleteItemByTabelaDeReferenciaId(params: any): Promise<ResponseApi>
  getBackofficeProducao(params: any): Promise<ResponseApi>
  getItensDoRepasse(params: any, id: string): Promise<ResponseApi>
  generateRelatorioGeracaoRepasse(params: any): Promise<ResponseApi>
  liberarRepasses(params: any): Promise<ResponseApi>
  liberarRepasseUnico(params: any): Promise<ResponseApi>
  integrarRepasses(params: any): Promise<ResponseApi>
  integrarRepasseUnico(params: any): Promise<ResponseApi>
  descartarRepasses(params: any): Promise<ResponseApi>
  getTipoCargaDownload(params: any): Promise<ResponseApi>
  enfileirar(params: any): Promise<ResponseApi>
  desfazerIntegracao(params: any): Promise<ResponseApi>
  desfazerLiberacao(params: any): Promise<ResponseApi>
  emitirRelatorio(params: any): Promise<ResponseApi>
  emitirRelatoriosEmLote(params: any): Promise<ResponseApi>
  emitirRelatorioTabelaPropria(params: any): Promise<ResponseApi>
  getEmissaoRelatorio(params: any): Promise<ResponseApi>
  getDescarteRepasses(params: any): Promise<ResponseApi>
  getRecalculoRepasse(params: any): Promise<ResponseApi>
  filtroDownloadNotaFiscal(params: any): Promise<ResponseApi>
  validarRepasses(params): Promise<ResponseApi>
  alterarSituacoesEmLote(params: any): Promise<ResponseApi>
  saveAluguelPrestador(params: any): Promise<ResponseApi>
  saveAlterarPontuacaoProfissional(params: any): Promise<ResponseApi>
  saveNovoItemAvulsoRepasse(params: any): Promise<ResponseApi>
  saveInsercaoDeRegistrosEmLoteCalcularRepasse(params: any): Promise<ResponseApi>
  putInsercaoDeRegistrosEmLoteCalcularRepasse(params: any): Promise<ResponseApi>
  putNovoItemFixoCargaPlanilha(params: any): Promise<ResponseApi>
  saveNovoItemAvulsoCalcularRepasse(params: any): Promise<ResponseApi>
  saveAlterarPrestador(params: any): Promise<ResponseApi>
  getGeracaoDeRepasseItensPrestador(params: any): Promise<ResponseApi>
  alterarFuncaoGeracaoRepasse(params: any): Promise<ResponseApi>
  getAllDescontosPrestador(params: any): Promise<ResponseApi>
  getProfissionalPontuacao(params: any): Promise<ResponseApi>
  getPontuacaoProfissional(): Promise<ResponseApi>
  getProcedimentos(): Promise<ResponseApi>
  getValidacaoErros(param: any): Promise<ResponseApi>
  getTransacaoFinanceira(): Promise<ResponseApi>
  getCentroDeCusto(): Promise<ResponseApi>
  getHistoricoSituacao(params: any): Promise<ResponseApi>
  getHistoricoGeracaoRepasse(params: any): Promise<ResponseApi>
  getValidacaoResultado(params: any): Promise<ResponseApi>
  getHistoricoCadastroAluguel(params: any): Promise<ResponseApi>
  getHistoricoGeracaoItens(params: any): Promise<ResponseApi>
  getHistoricoPontuacao(params: any): Promise<ResponseApi>
  getHistoricoPontuacaoProfissional(params: any): Promise<ResponseApi>
  getRegistrosValidacao(params: any): Promise<ResponseApi>
  fecharGeracaoRepasse(params: any): Promise<ResponseApi>
  getTabelasAMB(): Promise<ResponseApi>
  salvarCodigoAmb(params: any): Promise<ResponseApi>
  updateItemTabelaAmb(params: any): Promise<ResponseApi>
  saveEditTableRules(params: any): Promise<ResponseApi>
  deleteItemTabelaAmb(id: string): Promise<ResponseApi>
  getProfissionais(): Promise<ResponseApi>
  getPrestadoresRepasse(params: any): Promise<ResponseApi>
  getFuncoesProfissionalExecutante(): Promise<ResponseApi>
  getConveniosRepasse(params: any): Promise<ResponseApi>
  getPlanosRepasse(params: any): Promise<ResponseApi>
  getViasAcesso(): Promise<ResponseApi>
  getMotivoInclusao(): Promise<ResponseApi>
  getItemsRegrasProfissional(params: any): Promise<ResponseApi>
  getTabelaPrecoAll(): Promise<ResponseApi>
  getTabelaPrecoDetails(): Promise<ResponseApi>
  deleteItemTabelaPreco(id: number): Promise<ResponseApi>
  criarTabelaPreco(params: any): Promise<ResponseApi>
  getTabelaPrecoIndice(): Promise<ResponseApi>
  getConvenioRegras(): Promise<ResponseApi>
  getItemsTabelaAMB(params: any): Promise<ResponseApi>
  getConvenio(): Promise<ResponseApi>
  getItemsCargaRemuneracaoAll(params: any): Promise<ResponseApi>
  getItemsDownloadNotasFiscais(params: any): Promise<ResponseApi>
  desfazerRepasse(params: any): Promise<ResponseApi>
  getAllItemsSenioridade(params: any): Promise<ResponseApi>
  createItemsSenioridade(params: any): Promise<ResponseApi>
  updateItemsSenioridade(params: any): Promise<ResponseApi>
  deleteItemSenioridade(id: string): Promise<ResponseApi>
  getPontuacaoProfissionalAll(params: any): Promise<ResponseApi>
  getVinculosRelatorios(params: any): Promise<ResponseApi>
  getImpostoPrestadores(params: any): Promise<ResponseApi>
  criarVinculoRelatorio(params: any): Promise<ResponseApi>
  criarImpostoPrestador(params: any): Promise<ResponseApi>
  getRelatoriosAll(): Promise<ResponseApi>
  deleteVinculoRelatorio(params: any): Promise<ResponseApi>
  deleteImpostoPrestador(param: any): Promise<ResponseApi>
  createPontuacaoProfissional(params: any): Promise<ResponseApi>
  updatePontuacaoProfissional(params: any): Promise<ResponseApi>
  deletePontuacaoProfissional(id: string): Promise<ResponseApi>
  getTaxaAluguelAll(params: any): Promise<ResponseApi>
  createTaxaAluguel(params: any): Promise<ResponseApi>
  updateTaxaAluguel(params: any): Promise<ResponseApi>
  deleteTaxaAluguel(id: string): Promise<ResponseApi>
  excluirItemRepasse(params: any): Promise<ResponseApi>
  getStatusGeracaoRepasse(): Promise<ResponseApi>
  getGrupoHospital(): Promise<ResponseApi>
  getBackofficeChatItems(params: any): Promise<ResponseApi>
  getChatsInfo(param: any): Promise<ResponseApi>
  encerrarAtendimento(param: any): Promise<ResponseApi>
  integrarItensDeGeracaoDeRepasseNoHis(param: any): Promise<ResponseApi>
  liberarItensDeGeracaoDeRepasseNoHis(param: any): Promise<ResponseApi>
  getAllFeriados(params: any): Promise<ResponseApi>
  getAllAgendaGarantiaMinimaPeriodo(params: any): Promise<ResponseApi>
  getAgendaGarantiaMinimaPeriodoById(params: any): Promise<ResponseApi>
  deleteItemFeriado(param: any): Promise<ResponseApi>
  deleteItemAgendaGarantiaMinima(param: any): Promise<ResponseApi>
  createItemFeriado(param: any): Promise<ResponseApi>
  updateItemFeriado(param: any): Promise<ResponseApi>
  updateItemAgendaGarantiaMinimaPeriodo(params: any): Promise<ResponseApi>
  getListaPrestadores() : Promise<ResponseApi>
  getCalcularGarantiaMinima(params: any) : Promise<ResponseApi>
  calcularGarantiaMinima(params: any) : Promise<ResponseApi>
}

export {
  PrestadorRecebimento,
  IPrestadorRecebimento,
}
